export default __webpack_public_path__ + "static/media/chardhamhome.4f81b49e.jpg";